<template>
    <div>
        <div class="row" style="text-align: center">
                
                <div>
                    <img :src="$store.getters.getUserauthResponse.account_info.company_logo" 
                        alt="" srcset="" width="10%">
                </div>
                <span class="heading">
                        {{reportTitle}}
                    </span>
                    <span class="label">
                <span
                    v-for="(data, index) in basis"
                    :key="index">
                    {{data}}&nbsp; {{basis.length-1 == index ? '' : '|'}}&nbsp;
                </span>
                </span>
            
        </div>
    </div>
</template>

<script>
export default {
    props: ['reportTitle', 'basis']

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ReportHead/Index.vue